import React from "react";
import Text from "./Text";
import Sizes from "./Sizes";

interface Props {
  size?: Sizes;
  children?: React.ReactNode;
  className?: string;
  uppercase?: boolean;
  bold?: boolean;
  style?: React.CSSProperties;
  dataTestId?: string;
}

const Title = ({
  size = Sizes.large,
  className = "",
  uppercase = false,
  bold = false,
  children,
  style = {},
  dataTestId = "",
}: Props) => {
  const label = <Text>{children}</Text>;

  // Extend with other props
  const props = {
    className,
  };

  const getStyle = (styles?: React.CSSProperties) => {
    let updatedStyle = styles;
    if (uppercase) {
      updatedStyle = { ...updatedStyle, textTransform: "uppercase" };
    }
    if (bold) {
      updatedStyle = { ...updatedStyle, fontWeight: "bold" };
    }
    return updatedStyle;
  };

  switch (size) {
    case Sizes.medium:
      return (
        <h2 style={getStyle(style)} {...props} data-testid={dataTestId}>
          {label}
        </h2>
      );
    case Sizes.small:
      return (
        <h3 style={getStyle(style)} {...props} data-testid={dataTestId}>
          {label}
        </h3>
      );
    case Sizes.extrasmall:
      return (
        <h4 style={getStyle(style)} {...props} data-testid={dataTestId}>
          {label}
        </h4>
      );
    case Sizes.smallest:
      return (
        <h5 style={getStyle(style)} {...props} data-testid={dataTestId}>
          {label}
        </h5>
      );
    default:
      return (
        <h1 style={getStyle(style)} {...props} data-testid={dataTestId}>
          {label}
        </h1>
      );
  }
};

export default Title;
